import { Dispatch } from "redux";
import {QuicktipsActionTypes, QuicktipsAction} from "../../types/Quicktip/quicktipsTypes";
import axios from "axios";

interface ErrorResponse {
    code: number;
    message: string;
}

export const getQuicktipsData = (): any => {
    return async (dispatch: Dispatch<QuicktipsAction>) => {
        try {
            dispatch({ type: QuicktipsActionTypes.FETCH_QUICKTIPS_DATA });
            const response = await axios({
                method: 'get',
                url: `/api/quicktip_cards`,
                withCredentials: false
            });
            dispatch({ type: QuicktipsActionTypes.FETCH_QUICKTIPS_DATA_SUCCESS, payload: response.data });
        } catch (error: any) {
            let errorPayload: ErrorResponse;
            if (error.response && error.response.data) {
                const { code, message } = error.response.data;
                errorPayload = { code, message };
            } else {
                errorPayload = { code: -1, message: 'Unknown error occurred' };
            }
            dispatch({ type: QuicktipsActionTypes.FETCH_QUICKTIPS_DATA_ERROR, payload: errorPayload });
        }
    }
}
